import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { ButtonWithToggle } from 'modules/experiments/components/ui';
import { ExperimentSummaryInfoBanner } from './InfoBanner';
import { StyledTextHeader, StyledTableHeaderSectionWithToggle, StyledDivider } from './Styled';

export interface CardHeaderTypes {
  isToggleActive?: boolean;
  onClickToggle?: () => void;
}

export const ExperimentSummaryCardHeader = ({ isToggleActive, onClickToggle }: CardHeaderTypes) => {
  const { t } = useExperimentsTranslations();
  return (
    <>
      <ExperimentSummaryInfoBanner />
      <StyledDivider />
      <StyledTableHeaderSectionWithToggle>
        <StyledTextHeader>{t('cardHeading.variantVsControl')}</StyledTextHeader>
        <ButtonWithToggle isToggleActive={isToggleActive} onClick={onClickToggle}>
          {t('experimentSummary.showConfidenceInterval')}
        </ButtonWithToggle>
      </StyledTableHeaderSectionWithToggle>
    </>
  );
};
